const api = require('../firebaseConfig.js');

const state = {
  sections: {},
  pages: {},
  pageOrderList: [],
  currentPages: [],
  pageList: [],
  examples: {},
  contentLoading: true
};

const actions = {
  getContent({ dispatch, state }) {
    state.sections = {};
    state.pages = {};
    state.pageOrderList = [];
    state.contentLoading = true;

    api.Samsara.get().then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        const newContent = doc.data();
        if (doc.id === 'Popups') {
          state.sections = newContent;
        } else if (doc.id === 'Pages') {
          state.pages = newContent;
          state.currentPages = Object.keys(newContent);
        } else if (doc.id === 'PageOrder') {
          state.pageOrderList = newContent.order;
        } else if (doc.id === 'Examples') {
          state.examples = newContent;
        }
      });
      dispatch('updatePageList');
      state.contentLoading = false;
    });
  },
  updatePageList({ state }) {
    state.pageList = [];
    state.pageOrderList.forEach((page) => {
      if(state.currentPages.includes(page)) {
        state.pageList.push(page);
      }
    });
    state.currentPages.forEach((page) => {
      if(!state.pageOrderList.includes(page)) {
        state.pageList.push(page);
      }
    });
  },
  updateContent({ dispatch }, payload) {
    api.Samsara.doc('Popups')
      .update({
        [payload.section]: payload.newContent
      })
      .then(() => {
        dispatch('getContent');
      })
      .catch(function(error) {
        console.log('Error updating content ' + error);
      });
  },
  updateExample({ dispatch }, payload) {
    api.Samsara.doc('Examples')
      .update({
        [payload.section]: payload.newContent
      })
      .then(() => {
        dispatch('getContent');
      })
      .catch(function(error) {
        console.log('Error updating content ' + error);
      });
  },
  removeContent({ dispatch }, payload) {
    api.Samsara.doc('Popups')
      .update({
        [payload]: api.dbDel
      })
      .then(() => {
        dispatch('getContent');
      })
      .catch(function(error) {
        console.log('Error updating content ' + error);
      });
  },
  updatePage({ dispatch }, payload) {
    api.Samsara.doc('Pages')
      .update({
        [payload.name]: payload.content
      })
      .then(() => {
        dispatch('getContent');
      })
      .catch(function(error) {
        console.log('Error updating content ' + error);
      });
  },
  removePage({ dispatch }, payload) {
    api.Samsara.doc('Pages')
      .update({
        [payload]: api.dbDel
      })
      .then(() => {
        dispatch('getContent');
      })
      .catch(function(error) {
        console.log('Error updating content ' + error);
      });
  },
  updateOrder({ dispatch }, payload) {
    api.Samsara.doc('PageOrder')
    .update({
      order: payload
    })
    .then(() => {
      dispatch('getContent');
    })
    .catch(function(error) {
      console.log('Error updating content ' + error);
    });
  }
};
const getters = {
  contentItem: state => (item) => {
    return state.sections[item];
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters
};
